import React, { Component } from 'react';
import './base.min.css'
import './fancy.min.css'
import './main.css'
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import bg1 from '../../../../assets/bg1.png';
import bg2 from '../../../../assets/bg2.png';
import bg3 from '../../../../assets/bg3.png';
import bg4 from '../../../../assets/bg4.png';
import bg5 from '../../../../assets/bg5.png';
import bg6 from '../../../../assets/bg6.png';
import bg7 from '../../../../assets/bg7.png';
import moment from 'moment';



const placeholder= {
  company_name:'[Company name]',
  period:'[Select time period]',
  section1:'[Section 1 (ex. Your Feedback and Updates)',
  section2:'[Section 2 (ex. OurOffice Updates)',
  section3: '[Section 3 (ex. Monthly Observations -- Analytics)]',
  section4: '[Section 4 (ex. Monthly Observations -- Analytics)]',
  section5: '[Section 5 (ex. Monthly Observations -- Culture App)]',
  section6: '[Section 6 (ex. Monthly Observations -- Planning)]',
  section7: '[Section 7 (ex. Monthly Observations -- Toolkit)]',
  section8: '[Section 8 (ex. Monthly Recommendations)]'
}

class ReportLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
        searchedTerm:'',
        company_name:this.props.reports.temp&&this.props.reports.temp.company_name,
        newReport:{}
    }
    const printRef = React.createRef();

  }

  componentDidMount() {
    console.log(this.props)
    this.setState({ newReport: {
      ...this.props.reports.temp
    } })
  }


  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  }


  closeReport=()=>{
    this.props.closeReport()
  }


  renderDate=(period)=>{
  if(period && period!=null){
    if(period=='monthly'){
      return moment().format('MMM YYYY')
    } else if(period=='daily'){
      return  moment().format('MMM Do, YYYY')
    } else if (period=='yearly'){
      return moment().format('YYYY')
    } 
  }else{
    return placeholder.period
  }
}

  render() {
    let{newReport}=this.state
    console.log(newReport)
    
    return (
      <span>
        
        <div className="reportLayoutOptions">
            <button className='btn btn-success generatePdf'>Download pdf</button>
            <span className="filter-toggle-button btn btn-secondary-filled" onClick={this.closeReport}>Close preview</span>
        </div>
      
          <div 
          className="isPreviewReportContainer"
          // id="page-container"
          >
            <div id="pf1" className="pf w0 h0" data-page-no="1"><div className="pc pc1 w0 h0"><img className="bi x0 y0 w1 " alt="" src={bg1}/><div className="t m0 x1  y1 ff1 fs0 fc0 sc0 ls0 ws0">TM</div>
            <div className="t m0 x2  y2 ff2 fs1 fc1 sc0 ls0 ws0 reportLayoutPeriodTxt">{newReport.period?newReport.period:placeholder.period} Report</div>
            <div className="t m0 x2  y3 ff2 fs2 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}</div>
            <div className="t m0 x2  y4 ff2 fs2 fc2 sc0 ls0 ws0">Diversity, Equity and Inclusion</div>
            <div className="t m0 x2  y5 ff2 fs3 fc2 sc0 ls0 ws0">{this.renderDate(newReport.period)}</div>
            <div className="t m0 x3  y6 ff3 fs4 fc2 sc0 ls0 ws0">www.ouroffice.io</div><div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">1</div></div>
            </div>
            <div id="pf2" className="pf w0 h0" data-page-no="2">
              <div className="pc pc2 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg2}/>
              <div className="t m0 x5  y6 ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div>
            
            




            <div className="t m0 x6 h8 y8 ff4 fs6 fc1 sc0 ls0 ws0">{newReport.section1?newReport.section1:placeholder.section1}</div>
            <div className="t m0 x7 h8 y9 ff4 fs6 fc1 sc0 ls0 ws0">{newReport.section2?newReport.section2:placeholder.section2}</div>
            <div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">2</div></div>

            </div>
           






            <div id="pf3" className="pf w0 h0" data-page-no="3"><div className="pc pc3 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg3}/>
            <div className="t m0 x8 h9 ya ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section3?newReport.section3:placeholder.section3}</div>
            <div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">3</div>
            <div className="t m0 x5  yb ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div></div>
            </div>
           







            <div id="pf4" className="pf w0 h0" data-page-no="4"><div className="pc pc4 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg4}/>
            <div className="t m0 x8 h9 ya ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section4?newReport.section4:placeholder.section4}</div>
            <div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">4</div>
            <div className="t m0 x5  yb ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div></div>
            {/* <div className="pi" data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'></div> */}
            </div>
           






           
            <div id="pf5" className="pf w0 h0" data-page-no="5"><div className="pc pc5 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg5}/>
            <div className="t m0 x8 h9 ya ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section5?newReport.section5:placeholder.section5} </div><div className="t m0 x8 h9 yc ff2 fs6 fc1 sc0 ls0 ws0">(section 5)</div>
            <div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">5</div>
            <div className="t m0 x5  yb ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div></div>
            {/* <div className="pi" data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'></div> */}
            </div>
           
           






            <div id="pf6" className="pf w0 h0" data-page-no="6"><div className="pc pc6 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg6}/>
            <div className="t m0 x9 h9 yd ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section6?newReport.section6:placeholder.section6}</div>
            <div className="t m0 xa h9 yf ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section7?newReport.section7:placeholder.section7}</div></div>
            {/* <div className="pi" data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'></div> */}
            </div>
            <div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">6</div><div className="t m0 x5  ye ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div>





            <div id="pf7" className="pf w0 h0" data-page-no="7"><div className="pc pc7 w0 h0"><img className="bi x0 y0 w1 h1" alt="" src={bg7}/><div className="t m0 x5  y10 ff3 fs4 fc2 sc0 ls0 ws0">{newReport.company_name?newReport.company_name:placeholder.company_name}| {moment().format('MMM')} |  {moment().format('YYYY')}</div><div className="t m0 x4  y7 ff1 fs5 fc3 sc0 ls0 ws0">7</div>
            <div className="t m0 xb h9 y11 ff2 fs6 fc1 sc0 ls0 ws0">{newReport.section8?newReport.section8:placeholder.section8}</div></div>
            {/* <div className="pi" data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'></div> */}
            </div>
          </div>
      </span>
    );
  }
}


const mapStateToProps = state => {
	return {
		user: state.user.profile,
    reports: state.reports
	};
};


export default connect(mapStateToProps)(withRouter(ReportLayout));
